module.exports = __webpack_public_path__ + "static/img/ppt.b68eb231.png";